/**
* @Name: Service Constants
* @Creation Date: July 31, 2017
* @Author: sbaireddy
* @Version: 1.0 :
*/
export let STORE_ID: string = 'storeId';
export let ORDER_ID: string = 'orderId';
export let ZIP_CODE: string = 'zipCode';
export let PRODUCT_TYPE: string = 'productType';
export let RATEPLAN_SOC: string = 'rateplanSOC';
export let DEVICE_SKU: string = 'deviceSKU';
export let FEATURE_SOC: string = 'featureSOC';
export let ACCESSORY_SKU: string = 'accessorySKU';

export let PACKAGE_ID: string    = 'packageId';
export let LINE_ID: string       = 'lineId';
export let ORDER_ITEM_ID: string = 'orderItemId';

export let IS_FINANCE_ORDER: string = 'isFinanceOrder';
export let LOGGING: boolean = true ;

export let PROMO_CODE: string = 'promoCode';
export let RETURN_ORDER_ID: string = 'returnOrderId';
export let PROGRAM_TYPE: string = 'programType';
export let SERIAL_NUMBER: string = 'serialNumber';
export let SIM_NUMBER: string = 'simNumber';
export let RETURN_TRACKING_NUMBER: string = 'trackingNumber';
export let CUSTOMER_ID: string = 'customerId';
export let USER_ID: string = 'userId';
